import { createApiClient } from "@donista/shared/api/client";
import { PHASE_PRODUCTION_BUILD } from "next/constants";
import { capturePosthogException } from "@/lib/safe-posthog";

export const api = createApiClient({
  baseUrl:
    process.env.NEXT_PHASE === PHASE_PRODUCTION_BUILD
      ? process.env.NEXT_PUBLIC_DONISTA_INTERNAL_API_URL!
      : process.env.NEXT_PUBLIC_DONISTA_API_URL!,
  onError: (error) => capturePosthogException(error),
});

